import React from 'react'
import PropTypes from 'prop-types'
import {Box, useStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'

/**
 * XxValueBadgeDisplay - Reusable component for displaying xx-value badge with currency
 * Renders currency symbol and value with badge label
 */
const XxValueBadgeDisplay = ({xxValue, badge, variant = 'plp'}) => {
    const styles = useStyleConfig('XxValueBadge', {variant})

    if (!xxValue || !badge) {
        return null
    }

    return (
        <Box className="xx-value-badge-display" {...styles?.container}>
            <Box className="xx-value-amount" {...styles?.amountWrapper}>
                <Box as="span" className="currency-symbol" {...styles?.currencySymbol}>
                    $
                </Box>
                <Box as="span" className="amount-value" {...styles?.amount}>
                    {xxValue}
                </Box>
            </Box>
            <Box
                className="badge-label"
                {...styles?.badgeLabel}
                dangerouslySetInnerHTML={{__html: badge}}
            />
        </Box>
    )
}

XxValueBadgeDisplay.propTypes = {
    xxValue: PropTypes.string.isRequired,
    badge: PropTypes.string.isRequired,
    variant: PropTypes.oneOf(['plp', 'pdp'])
}

export default XxValueBadgeDisplay
